import { trim } from 'lodash';
import { ParsedLinkedIn } from './interfaces/parsedLinkedIn.interface';

const LINKEDIN_URL_REGEX = /((http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/([\w]+\/)?in\/)[A-Za-z0-9-_.]{5,30}/;

export function parseLinkedIn(linkedIn: string): ParsedLinkedIn {
  linkedIn = trim(linkedIn);

  const url = linkedIn.toLowerCase();
  const matched = url.match(LINKEDIN_URL_REGEX);

  if (!matched) {
    return {
      label: linkedIn,
      url: `https://www.linkedin.com/search/results/people/?keywords=${url}`,
    };
  }

  const parsedUrl = matched[0];

  return {
    label: url.replace(matched[1], ''),
    url: parsedUrl.startsWith('http') ? parsedUrl.replace(/https?/, 'https') : 'https://' + parsedUrl,
  };
}
